<template>
  <v-expansion-panels class="expansion-panel-form" multiple v-model="panel">
    <v-expansion-panel>
      <v-expansion-panel-header color="#007BC3" style="padding: 16px 24px;">
        <template v-slot:actions>
          <v-icon color="white" class="font-weight-black">
            icon-up-arrow
          </v-icon>
        </template>
        <span class="white--text font-weight-bold" style="font-size: 20px">
          Minhas Pendências
        </span>
      </v-expansion-panel-header>
      <v-expansion-panel-content class="mt-4">
        <tabs :tabs="allTabs" v-model="currentTab">
          <template v-slot:processos>
            <Processos :loading="loading" @length="getLengthProcessos" />
          </template>

          <!-- <template v-slot:documentos>
            <Documentos />
          </template> -->
        </tabs>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import tabs from "../../../components/UI/Tabs";
import Processos from "./Processos";
import { mapActions, mapGetters } from "vuex";
import store from "../../process/_store";

// import Documentos from "./Processos";

export default {
  name: "MinhasPendencias",

  components: {
    tabs,
    Processos
    // Documentos
  },

  data: function() {
    return {
      show: true,
      panel: [0],
      page: 1,
      loading: false,
      pagePendencia: 1,
      processosPendentes: [],
      termoDeBusca: "",
      currentTab: "Processos",
      itemsPendencias: [],
      itemsPendenciasViagem: [],
      itemsPendenciasFundoFixo: [],
      allTabs: [
        {
          name: "Processos",
          count: ""
        }
        // {
        //   name: "Documentos"
        // }
      ]
    };
  },
  async created() {
    await this.getProcess();
    // await this.getProcessTypes();
    // await this.getProcessStatus();
    // await this.getDepartaments();
  },

  beforeCreate() {
    const STORE_AUTH = "$_process";

    if (!(STORE_AUTH in this.$store._modules.root._children))
      this.$store.registerModule(STORE_AUTH, store);
  },

  methods: {
    async getProcess(page) {
      this.page = page || 1;
      this.loading = true;
      await this.listProvider({
        page: this.page,
        pesquisa: this.termoDeBusca
      });
      this.loading = false;
    },
    ...mapActions({
      listProvider: "$_process/getPendingProcesses",
      getProcessTypes: "$_process/getProcessTypes",
      getProcessStatus: "$_process/getProcessStatus",
      getDepartaments: "$_process/getDepartaments"
    }),

    getLengthProcessos(length) {
      this.allTabs[0].count = length;
    }
  },
  computed: {
    ...mapGetters({
      processes: "$_process/pendingProcesses"
    })
  }
};
</script>
<style lang="scss">
.expansion-panel-form {
  margin: 24px 0px;
  font-size: 20px;

  .black-grey {
    color: #444444;
  }
  .styled-divider {
    border-color: rgba(0, 0, 0, 1);
    margin-top: 0;
  }
  .v-expansion-panel-header {
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 20px;
    line-height: 29px;
    color: white;
    padding: 0px;
  }

  .v-icon {
    color: white;
  }
}
.aguardando-status {
  background-color: #f6f4f4;

  .status {
    color: #039c4a;
  }
}
.andamento-status {
  background-color: #fef2c9;

  .status {
    color: #f39c12;
  }
}

.retornado-status {
  background-color: #f6f4f4;

  .status {
    color: black;
  }
}

.aprovado-status {
  background-color: #d0f6f9;

  .status {
    color: #039c4a;
  }
}

.correcao-status {
  background-color: #ffe9e8;

  .status {
    color: #e74c3c;
  }
}

.default-status {
  background-color: #f6f4f4;

  .status {
    color: black;
  }
}
a[href="#processos"].v-tab--active {
  background: #1976d2 !important;
  color: #fff !important;
}

a[href="#processos"] {
  background: #4789ca !important;
  color: #fff !important;
}
</style>
